@if (state().browser) {
<router-outlet></router-outlet>

<modal-outlet></modal-outlet>
<!-- <app-carousel></app-carousel> -->
<!-- <app-switcher></app-switcher> -->
}
